import Vue from 'vue'
import Router from 'vue-router'
import Pesquisa from '@/views/VPesquisa'
import Home from '@/views/VHome'
import Login from '@/components/login/VLogin'
import PesquisaPlacas from '@/views/VPesquisaPlaca'
import CadastroTelegram from '@/views/VCadastroTelegram'
import CadastroAlerta from '@/views/VCadastroAlerta'
import CadastroEmail from '@/views/VCadastroEmail'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [ 
    {
      path: '',
      component: Pesquisa
    }, {
      path: '/login',
      component: Login
    }, {
      path: '/home',
      component: Home
    },
    {
      path: '/pesquisaPlacas',
      component: PesquisaPlacas
    },
    {
      path: '/cadastroTelegram',
      component: CadastroTelegram
    },
    {
      path: '/cadastroAlerta',
      component: CadastroAlerta
    },
    {
      path: '/cadastroEmail',
      component: CadastroEmail
    }
  ]
})
